{
  "gunlukisler": {
    "GunlukIsler": "Günlük İşler",
    "Baslik": "Günlük İşler",
    "Yeni İş Ekle": "Yeni İş Ekle",
    "İş Detayı": "İş Detayı",
    "İş Bilgisi": "İş Bilgisi",
    "Tarih": "Tarih",
    "Saat": "Saat",
    "Başlama Saati": "Başlama Saati",
    "Bitiş Saati": "Bitiş Saati",
    "Açıklama": "Açıklama",
    "Açıklama / Not": "Açıklama / Not",
    "Ekle": "Ekle",
    "Sil": "Sil",
    "Kapat": "Kapat",
    "Vazgeç": "Vazgeç",
    "Silme Onayı": "Silme Onayı",
    "Bu kaydı silmek istediğinize emin misiniz?": "Bu kaydı silmek istediğinize emin misiniz?",
    "Bugün": "Bugün",
    "Ay": "Ay",
    "Hafta": "Hafta",
    "Gün": "Gün",
    "Liste": "Liste",
    "Bilgi": "Bilgi",
    "Data Yenile": "Verileri Kontrol Et",
    "Güncelle": "Güncelle",
    "Kayıt başarıyla oluşturuldu.": "Kayıt başarıyla oluşturuldu.",
    "Kayıt başarıyla güncellendi.": "Kayıt başarıyla güncellendi.",
    "Kayıt başarıyla silindi.": "Kayıt başarıyla silindi.",
    "GecmisTarihUyari": "Geçmiş tarihli kayıtlar üzerinde işlem yapılamaz."
  }
}
